import React from 'react';
import { CHAINS } from '../../constants';
import { useGlobalState } from '../../state/GlobalStateProvider';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import Logo from '../Logo/Logo';
import ThemedText from '../theme/ThemedText';
import DropdownFilter from './DropdownFilter';

const ChainDetails = ({ isActive, chain, onClick }) => {
  return (
    <Flexbox
      gap='0.5rem'
      fw
      justifyContent='flex-start'
      className={isActive ? 'chaindropdown_wrapper__active' : 'chaindropdown_wrapper__chainDetails'}
      onClick={() => onClick(chain?.id)}
    >
      <Logo src={chain?.logo} width={'1rem'} height={'1rem'} borderRadius='50%' />
      <FlexboxColumn gap='0' alignItems={'flex-start'}>
        <ThemedText.P>{chain?.name}</ThemedText.P>
        {/* <Flexbox gap='0.25rem'>
          <ThemedText.H5>45</ThemedText.H5>
          <ThemedText.H6>Apps</ThemedText.H6>
        </Flexbox> */}
      </FlexboxColumn>
    </Flexbox>
  );
};

const ChainDropdown = ({ filter, onChange }) => {
  const [{ chainMapping }] = useGlobalState();
  function onClick(chainId) {
    if (filter === Number(chainId)) return onChange(null);
    onChange(Number(chainId));
  }
  return (
    <DropdownFilter heading={filter ? CHAINS[filter]?.name : 'All Chains'} contentClassName={'chaindropdown_wrapper'}>
      <FlexboxColumn fw>
        <ThemedText.H6 weight='semi-bold'>REPUTATION BY CHAIN</ThemedText.H6>
        <FlexboxColumn gap='1rem' alignItems={'flex-start'} fw>
          {Object.values(CHAINS).map((chain, idx) => (
            <ChainDetails key={`chain_dropdown_${idx}`} isActive={chain.id === Number(filter)} chain={chain} onClick={onClick} />
          ))}
        </FlexboxColumn>
      </FlexboxColumn>
    </DropdownFilter>
  );
};

export default ChainDropdown;
